import React from 'react'
import { useState,useEffect } from 'react';
import ProductFunctions from '../../../../../functions/public/product';
import ApiUrl from '../../../../../configTools/apiUrl';

const ProductSelector = ({username,setSelectedProduct}) => {
    const [userProducts,setUserProducts] = useState([]);
    useEffect(()=>{
        ProductFunctions.UserListings(username,setUserProducts);
    },[username])
  return (
    <div className='reels_information_product_selector_container'>
        {userProducts.map((item,index)=>{
            return(
                <div className='reels_information_product_selector_item' key={index}>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "10px",
                        position: "relative",
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                    }}
                    onClick={()=>{setSelectedProduct(item)}}
                    >
                    </div>
                </div>
            )
        })}
    </div>
  )
}

export default ProductSelector
